import {
  DefaultApi,
  GetChecklistDto,
  GetErrorListDto,
  GetStepDefinitionDto,
  ToggleManualStepCompletionDto,
} from '../autogenerated/pokApiClient';

export interface StepDefinitionContextInterface {
  getAllActive: () => Promise<GetStepDefinitionDto[]>;
  getChecklist: (
    projectId: string,
    stageDefinitionId: string,
    profileId: string,
    month: Date,
  ) => Promise<GetChecklistDto>;
  toggleManualStepCompletion: (
    dto: ToggleManualStepCompletionDto,
  ) => Promise<void>;
  getErrorList: (
    projectId: string,
    stageDefinitionId: string,
    profileId?: string,
    month?: Date,
  ) => Promise<GetErrorListDto>;
}

export const StepDefinitionContext = (api: DefaultApi) => {
  return {
    getAllActive: () => api.stepDefinitionControllerGetAllActiveSteps(),
    getChecklist: (
      projectId: string,
      stageDefinitionId: string,
      profileId: string,
      month: Date,
    ) =>
      api.stepDefinitionControllerGetChecklist(
        projectId,
        stageDefinitionId,
        profileId,
        month,
      ),
    toggleManualStepCompletion: (dto: ToggleManualStepCompletionDto) =>
      api.stepDefinitionControllerToggleManualStepCompletion(dto),
    getErrorList: (
      projectId: string,
      stageDefinitionId: string,
      profileId?: string,
      month?: Date,
    ) =>
      api.stepDefinitionControllerGetErrorList(
        projectId,
        stageDefinitionId,
        profileId,
        month,
      ),
  };
};
